import React, { useRef, useState, useEffect } from 'react';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import { func, shape } from 'prop-types';

import pinTooltip from '~assets/map/pin-tooltip-es.svg';
import {
  INITIAL_MAP_POSITION,
  DEFAULT_ZOOM,
  CONTAINER_MAP_CONFIG
} from '~screens/Dashboard/components/ChangeAddress/constants';

function SearchAddressMap({ currentAddress, onMarkerDragEnd, onMapDragEnd }) {
  const markerGeolocation =
    (currentAddress && { lat: currentAddress.latitude, lng: currentAddress.longitude }) ||
    INITIAL_MAP_POSITION;

  const [center, setCenter] = useState(markerGeolocation);
  const refMap = useRef(null);
  const markerRef = useRef(null);

  const onBoundsChanged = () => {
    const latLngPayload = {
      lat: refMap.current.map.getCenter().lat(),
      lng: refMap.current.map.getCenter().lng()
    };
    setCenter({ ...latLngPayload });
  };

  useEffect(() => {
    if (!currentAddress) {
      return;
    }
    const currentLat = parseFloat(currentAddress.latitude);
    const currentLng = parseFloat(currentAddress.longitude);
    if (currentLat !== center.lat || currentLng !== center.lng) {
      setCenter({ lat: currentLat, lng: currentLng });
      refMap.current.map.panTo({ lat: currentLat, lng: currentLng });
    }
  }, [currentAddress, center]);

  return (
    <div className="column full-width center middle">
      <Map
        ref={refMap}
        zoom={DEFAULT_ZOOM}
        google={window.google}
        initialCenter={center}
        containerStyle={CONTAINER_MAP_CONFIG}
        streetViewControl={false}
        mapTypeControl={false}
        fullscreenControl={false}
        onDragend={(ev, map) => onMapDragEnd(map)}
        onCenter_changed={onBoundsChanged}>
        <Marker
          ref={markerRef}
          draggable
          position={center}
          onDragend={(ev, map, coord) => onMarkerDragEnd(coord, window.google)}
          icon={{
            url: pinTooltip,
            scaledSize: new window.google.maps.Size(180, 92)
          }}
        />
      </Map>
    </div>
  );
}

SearchAddressMap.defaultProps = {
  onMapDragEnd: () => undefined
};

SearchAddressMap.propTypes = {
  currentAddress: shape({}),
  onMapDragEnd: func,
  onMarkerDragEnd: func
};

// eslint-disable-next-line
export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
})(SearchAddressMap);
